import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { IMAGES } from '../data/landing';
const lineas = [{
  label: 'Saga completa de 4 Tomos (250 recetas)',
  valor: '$39.990'
}, {
  label: 'Bonus 1 — Tabla de Tiempos y Temp.',
  valor: '$14.900'
}, {
  label: 'Bonus 2 — Menú "Mes Resuelto"',
  valor: '$17.900'
}, {
  label: 'Bonus 3 — Carnes Baratas que saben a Lomo',
  valor: '$15.900'
}, {
  label: 'Bonus 4 — 50 Recetas Fit e Hiper-Proteicas',
  valor: '$18.900'
}, {
  label: 'Bonus 5 — Guía de Limpieza y Mantenimiento',
  valor: '$13.900'
}];
export function OfferSection() {
  return <section id="oferta-principal" className="w-full bg-neutral-950 py-10 text-white sm:py-16" data-id="element-122" data-mp="rc3f9tve1ssw">
      <div className="mx-auto max-w-2xl px-4 sm:px-6" data-id="element-123" data-mp="wan5w7kxfsrl">
        <div className="text-center" data-id="element-124" data-mp="2t6kwk3kz62qp">
          <img src={IMAGES.mockupPrincipal} alt="MegaPack Air Fryer Argentina con 4 tomos y 5 bonos incluidos" className="mx-auto mb-6 w-full max-w-md drop-shadow-2xl" data-id="element-125" data-mp="2t7mbij5439dp" />
          <h2 className="text-2xl font-black leading-tight sm:text-3xl lg:text-4xl" data-id="element-126" data-mp="12p34n22j7en4">
            Mirá todo lo que te llevás hoy
          </h2>
          <p className="mt-3 text-base text-neutral-400" data-id="element-127" data-mp="sxp36or0s4rc">
            Un solo pago. Acceso de por vida. Sin suscripciones ni letra chica.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mt-8 rounded-3xl border border-neutral-800 bg-neutral-900 p-6 sm:p-8" data-id="element-128" data-mp="oxydyph55wox">
          <ul className="space-y-3" data-id="element-129" data-mp="1cjv64gz8iln6">
            {lineas.map(l => <li key={l.label} className="flex items-center justify-between gap-3 border-b border-neutral-800 pb-3 text-sm sm:text-base" data-id="element-130" data-mp="17neh7kk7o391">
                <span className="flex items-center gap-2 text-neutral-200" data-id="element-131" data-mp="17ub4kbs20yz">
                  <CheckIcon className="h-4 w-4 shrink-0 text-green-500" data-id="element-132" data-mp="3sc13zmbuvgk8" />
                  {l.label}
                </span>
                <span className="shrink-0 text-neutral-400 line-through" data-id="element-133" data-mp="3tusnyevgpjrk">{l.valor}</span>
              </li>)}
          </ul>

          <div className="mt-5 space-y-1 text-right" data-id="element-134" data-mp="3ktbdpd4qkcas">
            <p className="text-sm text-neutral-400" data-id="element-135" data-mp="3ksjhq1788cjz">
              Valor total del MegaPack + bonos:{' '}
              <span className="font-bold text-neutral-300 line-through" data-id="element-136" data-mp="3otbsiyvqypid">$121.490</span>
            </p>
          </div>

          <div className="mt-4 overflow-hidden rounded-2xl border border-yellow-400/30 bg-neutral-950 text-center" data-id="element-137" data-mp="3b1f1yz9q8no3">
            <div className="bg-yellow-400 px-4 py-2 text-xs font-black uppercase tracking-widest text-neutral-950" data-id="element-138" data-mp="315c2602cl14b">
              Oferta especial de hoy · 63% OFF
            </div>
            <div className="p-6" data-id="element-139" data-mp="362c8mc3405vy">
              <p className="text-sm font-bold uppercase tracking-widest text-neutral-400" data-id="element-140" data-mp="2s4vx4m5yhlxc">
                Antes
              </p>
              <p className="mt-1 text-2xl font-black text-neutral-500 line-through sm:text-3xl" data-id="element-141" data-mp="2x2fe3tu1gcsz">
                $39.990
              </p>
              <p className="mt-4 text-sm font-bold uppercase tracking-widest text-neutral-400" data-id="element-142" data-mp="2djryerom3nx9">
                Hoy te llevás todo por
              </p>
              <p className="mt-1 text-5xl font-black text-yellow-400 sm:text-6xl" data-id="element-143" data-mp="2mjoe43t0xcg6">
                $14.900
              </p>
              <p className="mt-4 inline-flex rounded-full bg-green-600 px-4 py-2 text-sm font-black text-white" data-id="element-144" data-mp="2ifqfrvbiw5o6">
                RECIBÍS $81.500 EN BONOS GRATIS HOY
              </p>
              <p className="mt-3 text-sm text-neutral-400" data-id="element-145" data-mp="2rgx1cit146oa">
                Pago único · Equivale a un solo delivery que te llega frío.
              </p>
            </div>
          </div>

          <div className="mt-6" data-id="element-146" data-mp="318kkzxjcgjf7">
            <CtaButton checkout showPaymentSeal data-id="element-147" data-mp="318b36x8gdikl" />
          </div>
        </motion.div>
      </div>
    </section>;
}